import React, { useEffect, useState } from "react";
import Sidebar from "../../comman_page/Sidebar";
import { HeaderDashboard } from "../../comman_page/HeaderDashboard";
import { Container, Row, Col, Spinner, Button } from "react-bootstrap";
import { Footer } from "../../../../../public/containers/footer/Footer";
import { dCodeTransactionListAPI } from "../../../../../Studio-Services/Studio_Services";
import { SharedButton } from "../../../../../sharedComponents/Button";

import { BiSearchAlt, BiWindowClose, BiXCircle } from "react-icons/bi";
import moment from "moment";


import { DatePicker } from "antd"
import { NewDateRange } from "../../../../../sharedComponents/NewDateRange";
const { RangePicker } = DatePicker;


export const D_CodeReport = () => {
    const [loader, setLoader] = useState(false);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();

    const [selectedDate, setSelectedDate] = useState();
    const [dvalue, setDvalue] = useState();

    const [fullData, setFullData] = useState();
    const [totalDetail, setTotalDetail] = useState([]);


    const getReport = async () => {
        const payload = { startDate, endDate };
        setLoader(true);
        try {
            const resp = await dCodeTransactionListAPI(payload);
            if (resp) {
                let data = resp.data;
                console.log(resp.data);
                if (resp?.data?.length == 0) {
                    setFullData();
                    setTotalDetail([]);
                    return;
                }
                setFullData(data);
                let tr = 0;
                let TotalPrice = 0;
                let TotalDiscount = 0;
                let AdjustPrice = 0;
                let Tax1 = 0;
                let Tax2 = 0;
                let Total = 0;

                (data ?? []).forEach((e, index) => {
                    tr = index + 1;
                    TotalPrice += parseFloat(e.finalBaseAmount);
                    TotalDiscount += parseFloat(e.discount);
                    AdjustPrice += parseFloat(e.finalAdjustPrice);
                    Tax1 += parseFloat(e.finalTax1);
                    Tax2 += parseFloat(e.finalTax2);
                    Total += parseFloat(e.finalSubTotal);
                })
                const Final = [{
                    Transaction: tr,
                    TotalPrice: parseFloat(TotalPrice).toFixed(2),
                    TotalDiscount: parseFloat(TotalDiscount).toFixed(2),
                    AdjustPrice: parseFloat(AdjustPrice).toFixed(2),
                    TotalTax1: parseFloat(Tax1).toFixed(2),
                    TotalTax2: parseFloat(Tax2).toFixed(2),
                    FinalTotal: parseFloat(Total).toFixed(2)
                }]
                setTotalDetail(Final);
                setLoader(false);
            }
        } catch (error) {
            console.log("---@Error------", error);
        } finally {
            setLoader(false);
        }
    }

    useEffect(() => {
        const start = moment().startOf("month").format("YYYY-MM-DD");
        const end = moment().endOf("month").format("YYYY-MM-DD");
        setStartDate(start);
        setEndDate(end);
        setSelectedDate([
            moment().startOf("month"),
            moment().endOf("month")
        ]);
    }, []);


    useEffect(() => {
        getReport();
    }, [startDate, endDate]);


    // const handleDateChange = (value) => {
    //     if (value && value.length === 2) {
    //         setSelectedDate(value);
    //         console.log(value);
    //         const formattedStartDate = moment(value[0].$d).format("YYYY-MM-DD");
    //         const formattedEndDate = moment(value[1].$d).format("YYYY-MM-DD");
    //         setStartDate(formattedStartDate);
    //         setEndDate(formattedEndDate);
    //     } else {
    //         setStartDate(null);
    //         setEndDate(null);
    //     }
    // };

    const clearHandler = () => {
        const start = moment().startOf("month").format("YYYY-MM-DD");
        const end = moment().endOf("month").format("YYYY-MM-DD");
        setStartDate(start);
        setEndDate(end);
    }
    return (
        <>
            {loader && <div className='MainLoader'> <Spinner animation="border" role="status" className='Loader'> </Spinner> </div>}
            <div className="MainDashboard">
                <div className="MainLayout">
                    <Row>
                        <Sidebar />
                        <Col>
                            <div className="RightSide">
                                <HeaderDashboard />
                                <section className="addClient innerContent">
                                    <div className="AddClientContent">
                                        <Container>
                                            <h4 className="mb-4">Discount Code Transaction Report</h4>
                                            <Row>
                                                <Col>
                                                    <div className="mb-3 daterange_parent">
                                                        <NewDateRange
                                                            setDvalue={setDvalue}
                                                            dvalue={dvalue}
                                                            setStartDate={setStartDate}
                                                            setEndDate={setEndDate}

                                                        />
                                                    </div>
                                                </Col>
                                                <Col>
                                                </Col>
                                                <Col className="text-right">
                                                    <SharedButton
                                                        title={"Back"}
                                                        className={"backBtn"}
                                                        type={"button"}
                                                        onClick={() => {
                                                            window.history.back();
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={12}>
                                                    <table className="table table-striped">
                                                        <thead>
                                                            <tr>
                                                                <th>Total Transactions</th>
                                                                <th>Total Price</th>
                                                                <th>Total Discount</th>
                                                                <th>Adjust Price</th>
                                                                <th>Tax 1</th>
                                                                <th>Tax 2</th>
                                                                <th>Total Payable</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {(totalDetail ?? []).map((row, index) =>
                                                                <tr key={index}>
                                                                    <td>{row.Transaction}</td>
                                                                    <td>$ {row.TotalPrice}</td>
                                                                    <td>-$ {row.TotalDiscount}</td>
                                                                    <td>$ {row.AdjustPrice}</td>
                                                                    <td>$ {row.TotalTax1}</td>
                                                                    <td>$ {row.TotalTax2}</td>
                                                                    <td>$ {row.FinalTotal}</td>
                                                                </tr>)}
                                                        </tbody>

                                                    </table>
                                                </Col>
                                            </Row>
                                            {totalDetail && totalDetail?.length == 0 &&
                                                <Row>
                                                    <Col md={12} style={{ display: 'flex', justifyContent: 'center', padding: '70px 0px' }}>
                                                        No Data Available
                                                    </Col>
                                                </Row>
                                            }
                                            {totalDetail && totalDetail?.length > 0 &&
                                                <Row>
                                                    <Col>
                                                        <SharedButton
                                                            title={"View Details"}
                                                            type={"button"}
                                                            element={fullData}
                                                            href={"/discountTrDetails"}
                                                            variant={"secondary"}
                                                            className={'text-capitalize'}
                                                        />
                                                    </Col>
                                                    <Col></Col>
                                                    <Col></Col>
                                                </Row>
                                            }
                                        </Container>
                                    </div>
                                </section>
                                <Footer />
                            </div>
                        </Col>
                    </Row >
                </div >
            </div >
        </>
    );
};
